import script from "./SizesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SizesList.vue?vue&type=script&setup=true&lang=ts"

import "./SizesList.scss?vue&type=style&index=0&id=4be41d0c&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4be41d0c"]])

export default __exports__